import ReducerAction from "./ReducerAction";

export default (state, action) => {
  switch (action.type) {
    case ReducerAction.store.updateState:
      return {
        ...state,
        stateUpdate: Math.random(),
      };
    default:
      return state;
  }
};
